"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTask = getTask;
exports.MSGCT_SUBMSG = void 0;

var _skAxios = require("sk-axios");

var MSGCT_MSG = "".concat(process.env.BASE_MODULE_API, "/msgct/msg");
var MSGCT_SUBMSG = "".concat(process.env.BASE_MODULE_API, "/msgct/subMsg");
exports.MSGCT_SUBMSG = MSGCT_SUBMSG;

function getTask(params) {
  return (0, _skAxios.post)("".concat(MSGCT_MSG, "/detail"), params).then(function (response) {
    return response.data.content;
  });
}